import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLinkedinIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="linkedin-icon-small_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 35 35"
    {...props}
  >
    <defs>
      <style>{'.linkedin-icon-small_svg__cls-1{isolation:isolate}'}</style>
    </defs>
    <g
      id="linkedin-icon-small_svg__Linkedin"
      className="linkedin-icon-small_svg__cls-1"
    >
      <path
        d="M736.81 665.592v29.953a2.52 2.52 0 0 1-2.5 2.523h-30.007a2.51 2.51 0 0 1-2.493-2.523v-29.953a2.51 2.51 0 0 1 2.493-2.524h30.007a2.517 2.517 0 0 1 2.5 2.524m-24.007 5.484a3.008 3.008 0 1 0-3.008 3.008 3.014 3.014 0 0 0 3.008-3.008m-.406 21.992v-16.703H707.2v16.703zm19.437-9.156c0-4.5-.977-7.96-6.227-7.96a5.46 5.46 0 0 0-4.914 2.695h-.07v-2.282h-4.976v16.703h5.187v-8.265c0-2.18.414-4.29 3.118-4.29 2.656 0 2.695 2.493 2.695 4.43v8.126h5.187Z"
        className="linkedin-icon-small_svg__cls-1"
        style={{
          fill: '#4875b4',
        }}
        transform="translate(-701.81 -663.068)"
      />
    </g>
  </svg>
);
export default SvgLinkedinIconSmall;
